import { render, staticRenderFns } from "./statusPendingDetails.vue?vue&type=template&id=284aa620&scoped=true&"
import script from "./statusPendingDetails.vue?vue&type=script&lang=js&"
export * from "./statusPendingDetails.vue?vue&type=script&lang=js&"
import style0 from "./statusPendingDetails.vue?vue&type=style&index=0&id=284aa620&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284aa620",
  null
  
)

export default component.exports